<script>
import { Option } from 'element-ui';

export default {
  extends: Option,
};
</script>
